import {
  ColoursObj,
  IDrawerStore,
  MobileDialog,
  MobileDrawer,
  MobileSnackBar,
  TMobileDialog,
  TSnackListStore,
  useDialogStore,
  useDrawerStore,
  useSnackListStore,
} from "@eventr/common-storybook";
import { useNativeNavigationViewContext } from "@eventr/native/navigation/react";
import { Toast } from "@eventr/native/toast";
import { Backdrop, CircularProgress } from "@mui/material";
import { FC, Fragment, useEffect } from "react";
import { IImageFrameStore, ImageFrame, useImageFrameStore } from "./MobileImageFrame";
import { isIosToastAvailable } from "./native-toast";
import { useOverlayStore } from "./overlay.store";

export const OverlayWrapper: FC<{ children: any }> = ({ children }) => {
  const loading = useOverlayStore((s) => s.loading);
  const snackListStore: TSnackListStore = useSnackListStore();
  const dialogStore: TMobileDialog = useDialogStore();
  const drawerStore: IDrawerStore = useDrawerStore();
  const imageFrameStore: IImageFrameStore = useImageFrameStore();
  const closeImageFrame = useImageFrameStore((s) => s.closeImageFrame);
  const { addViewDidDisappearListener } = useNativeNavigationViewContext();

  useEffect(() => {
    return addViewDidDisappearListener(() => {
      closeImageFrame();
      if (!isIosToastAvailable()) return;
      void Toast.hideAll().catch(() => {});
    });
  }, [addViewDidDisappearListener, closeImageFrame]);

  /**
   * Backdrop for loading overlay
   */
  const loadingBackdrop = (
    <Backdrop
      sx={{
        color: ColoursObj.shades.shade3,
        backgroundColor: "transparent",
        backdropFilter: "blur(3px)",
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      open={loading}
    >
      <CircularProgress id="Loading-signal" color="inherit" />
    </Backdrop>
  );

  return (
    <Fragment>
      <MobileSnackBar
        snackList={snackListStore.snackList}
        onClose={(_, reason) => {
          if (reason === "timeout") {
            snackListStore.clearList();
          }
        }}
      />
      <MobileDialog dialog={dialogStore.dialog} />
      <MobileDrawer drawer={drawerStore.drawer} openState={drawerStore.openState} />
      <ImageFrame open={imageFrameStore.open} imageSource={imageFrameStore.source ?? undefined} />
      {loading && loadingBackdrop}
      {children}
    </Fragment>
  );
};
